import { render, staticRenderFns } from "./ComponentTextPersona.vue?vue&type=template&id=ae270bc0"
import script from "./ComponentTextPersona.vue?vue&type=script&lang=js"
export * from "./ComponentTextPersona.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae270bc0')) {
      api.createRecord('ae270bc0', component.options)
    } else {
      api.reload('ae270bc0', component.options)
    }
    module.hot.accept("./ComponentTextPersona.vue?vue&type=template&id=ae270bc0", function () {
      api.rerender('ae270bc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/reporting/ComponentTextPersona.vue"
export default component.exports